// extracted by mini-css-extract-plugin
export var aiStarIcon = "_u8-2";
export var container = "_u8-4";
export var dismissButton = "_u8-3";
export var hasPaddingBottom = "_u8-6";
export var last = "_u8-e";
export var scrollbarThumb = "_u8-c";
export var scrollbarTrack = "_u8-b";
export var selected = "_u8-9";
export var spin = "_u8-1";
export var spinning = "_u8-0";
export var suggestionItem = "_u8-d";
export var suggestionsPanel = "_u8-5";
export var tonePill = "_u8-8";
export var tonesContainer = "_u8-7";
export var unselected = "_u8-a";